import ObjectModelEntry from "../../../common/models/objectModelEntries/objectModelEntry";
import Selected from "../store/modules/selected";
import User from "../../../common/models/user";
import ObjectModel from "../../../common/models/objectModel";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import {ObjectModelRelationType} from "~/enums/objectModelRelationType";

export default {
  computed: {
    currentUser(): User {
      return Selected.currentUser.get();
    },
    // object models
    selectedObjectModel(): ObjectModel {
      return Selected.objectModel.get();
    },
    selectedRelatedObjectModels(): ObjectModel[] {
      return ObjectModel.repo.findWhere(om => om.client_id !== this.selectedObjectModel.client_id)
    },
    selectedInverseObjectModels(): ObjectModel[] {
      return ObjectModel.repo.findWhere(om => om.client_id !== this.selectedObjectModel.client_id)
    },
    // object model entries
    selectedObjectModelEntry(): ObjectModelEntry {
      return Selected.objectModelEntry.get();
    },
    selectedRelatedObjectModelEntries(): ObjectModelEntry[] {
      return ObjectModelEntry.repo.findWhere(ome => ome.client_id !== this.selectedObjectModelEntry.client_id)
    },
    selectedInverseObjectModelEntries(): ObjectModelEntry[] {
      return ObjectModelEntry.repo.findWhere(ome => ome.client_id !== this.selectedObjectModelEntry.client_id)
    },
    // object model relations


    selectedObjectModelRelations(): ObjectModelRelation[] {  
      return ObjectModelRelation.repo.findWhere(omr => omr.object_model_id === this.selectedObjectModel.object_model_id)
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedObjectModelRelationsOptional(): ObjectModelRelation[] {
      return ObjectModelRelation.repo.findWhere(omr => !omr.is_required && omr.object_model_id === this.selectedObjectModel.object_model_id)
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedInverseObjectModelRelations(): ObjectModelRelation[] {            
      return ObjectModelRelation.repo.findWhere(omr => omr.related_object_model_ids.includes(this.selectedObjectModel.object_model_id))
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedObjectModelRelationsRequired(): ObjectModelRelation[] {
      return ObjectModelRelation.repo.findWhere(omr => omr.is_required && omr.object_model_id === this.selectedObjectModel.object_model_id)
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedInverseObjectModelRelationsRequired(): ObjectModelRelation[] {            
      return ObjectModelRelation.repo.findWhere(omr => omr.is_required && omr.related_object_model_ids.includes(this.selectedObjectModel.object_model_id))
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedInverseObjectModelRelationsOptional(): ObjectModelRelation[] {            
      return ObjectModelRelation.repo.findWhere(omr => omr.related_object_model_ids.includes(this.selectedObjectModel.object_model_id))
        .filter(omr => !omr.isAccountRelationship);
    },
    selectedAccountRelationships(): ObjectModelRelation[] {
      return ObjectModelRelation.repo.findWhere(omr => omr.isAccountRelationship);
    }
  },
}